<template>
  <div>
    <h2 class="title">{{ $t("page.order.confirmation.deliveryaddress") }}</h2>

    <v-order-confirmation-address-form
      v-if="state === 'ADDRESS_FORM'"
      @cancel="
        state = 'LIST';
        editedAddress = null;
      "
      :address="editedAddress"
      @created="onNewAddressCreated"
      @updated="onAddressUpdated"
      @deleted="$emit('update')"
    />
    <div v-else-if="state === 'LIST'">
      <div class="address-list">
        <v-radio-group
          item-class="address-item"
          :options="addresses"
          :value="selectedAddressId"
          @input="(id) => $emit('update:selectedAddressId', id)"
        >
          <template v-slot="{ option: address }">
            <div class="address">
              <div class="pv-10">
                <template v-if="basicData.checkoutDisplayMode !== 'us'">
                  <div>
                    {{
                      `${address.name1} ${address.name2}${address.nameSuffix.length ? `, ${address.nameSuffix}` : ""}`
                    }}
                  </div>
                  <div>
                    {{ address.streetHouseNumber }}, {{ address.zipCode }} {{ address.city }},
                    {{ $t(address.countryTranslationKey) }}
                  </div>
                </template>
                <template v-if="basicData.checkoutDisplayMode === 'us'">
                  <div>
                    {{
                      `${address.name1} ${address.name2}${address.nameSuffix.length ? `, ${address.nameSuffix}` : ""}`
                    }}
                  </div>
                  <div>
                    {{ address.streetHouseNumber }}
                  </div>
                  <div>{{ address.city }}, {{ address.zipCode }}</div>
                  <div>
                    {{ $t(address.countryTranslationKey) }}
                  </div>
                </template>
              </div>
              <a v-if="address.editable" href="#" @click.prevent.stop="editAddress(address)" class="address__edit">
                <img src="~@/assets/icons/pencil.svg" class="mr-10" />
              </a>
            </div>
          </template>
        </v-radio-group>
      </div>
      {{ $t("page.order.address.change.info") }}
      <!--Disabled for now, implemented later-->
      <!--<div class="mt-30 mb-20">
        <v-button
          v-if="basicData.checkoutDisplayMode !== 'us'"
          id="new-address-button"
          class="no-border no-outline new-address"
          white
          @click="state = 'ADDRESS_FORM'"
        >
          <img src="~@/assets/icons/icon-plus.svg" class="icon-left" />
          {{ $t("page.order.confirmation.addnewaddress") }}
        </v-button>
      </div>-->
    </div>
    <div class="mt-50 text-right order-confirmation-popup__footer" v-if="state !== 'ADDRESS_FORM'">
      <v-button class="order-confirmation-form__continue" primary @click="$emit('continue')">
        {{ $t("common.continue") }}
        <svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1.28859 9.88047L5.16859 6.00047L1.28859 2.12047C0.898594 1.73047 0.898594 1.10047 1.28859 0.710469C1.67859 0.320469 2.30859 0.320469 2.69859 0.710469L7.28859 5.30047C7.67859 5.69047 7.67859 6.32047 7.28859 6.71047L2.69859 11.3005C2.30859 11.6905 1.67859 11.6905 1.28859 11.3005C0.908594 10.9105 0.898594 10.2705 1.28859 9.88047Z"
            fill="#FDFDFD"
          />
        </svg>
      </v-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { VButton, VRadioGroup } from "shared";
import VOrderConfirmationAddressForm from "./v-order-confirmation-address-form";

export default {
  name: "VOrderConfirmationPopup",
  components: {
    VButton,
    VRadioGroup,
    VOrderConfirmationAddressForm,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    addresses: {
      type: Array,
      default: () => [],
    },
    selectedAddressId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      editedAddress: null,
      progressIndex: 1,
      state: "LIST",
    };
  },

  computed: {
    ...mapGetters("order", ["basicData"]),
  },

  methods: {
    editAddress(address) {
      this.editedAddress = { ...address };
      this.state = "ADDRESS_FORM";
    },
    async onNewAddressCreated(addressId) {
      this.$emit("update:selectedAddressId", addressId);
      this.$emit("update");
    },
    async onAddressUpdated(updatedAddress) {
      this.state = "LIST";
      this.editedAddress = null;
      Object.assign(
        this.addresses.find((address) => address.id === updatedAddress.id),
        updatedAddress
      );
      this.$emit("update");
    },
  },
};
</script>

<style lang="scss" scoped>
.new-address {
  padding-left: 20px;
  background: none;
}

.title {
  font-size: 24px;
  margin: 53px 0 23px 0;
  letter-spacing: 0.9px;
}

::v-deep .radio-group {
  &__inner {
    border-bottom: 1px solid #ececec;
    margin-bottom: 22px;
  }
}
.footer {
  position: absolute;
  left: 0;
  right: 64px;
  bottom: 64px;
}

.address {
  cursor: pointer;
  position: relative;
  width: calc(100% - 23px);
  font-size: 13px;
  line-height: 16px;
  padding: 0 30px 20px 11px;
  letter-spacing: 0.5px;
  &__edit {
    position: absolute;
    right: -9px;
    top: 3px;
  }
}
</style>
